// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Js_exn = require("rescript/lib/js/js_exn.js");
var Belt_Id = require("rescript/lib/js/belt_Id.js");
var MM_context = require("./MM_context.res.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Belt_HashMap = require("rescript/lib/js/belt_HashMap.js");
var Core__Option = require("@rescript/core/src/Core__Option.res.js");
var MM_proof_tree = require("./MM_proof_tree.res.js");
var MM_syntax_tree = require("./MM_syntax_tree.res.js");
var Caml_splice_call = require("rescript/lib/js/caml_splice_call.js");
var Expln_utils_common = require("../../rescript-utils/main/Expln_utils_common.res.js");

function buildSyntaxTreeInner(proofNode, ctxIntToAsrtInt, asrtIntToSym, ctxHypLabelAndAsrtVarToAsrtHypLabel, idSeq) {
  var expr = MM_proof_tree.pnGetExpr(proofNode);
  var match = MM_proof_tree.pnGetProof(proofNode);
  if (match === undefined) {
    return {
            TAG: "Error",
            _0: "Cannot build a syntax tree from a node without proof."
          };
  }
  if (typeof match !== "object") {
    return Js_exn.raiseError("buildSyntaxTreeInner.VarType");
  }
  switch (match.TAG) {
    case "Hypothesis" :
        var label = match.label;
        var maxI = expr.length - 1 | 0;
        var children = new Array(maxI);
        var parentNodeId = idSeq();
        for(var i = 1; i <= maxI; ++i){
          var symInt = ctxIntToAsrtInt(expr[i]);
          children[i - 1 | 0] = {
            TAG: "Symbol",
            id: idSeq(),
            symInt: symInt,
            sym: asrtIntToSym(symInt),
            color: undefined,
            isVar: symInt >= 0
          };
        }
        var label$1;
        if (children.length === 1) {
          var match$1 = children[0];
          label$1 = match$1.TAG === "Subtree" || !match$1.isVar ? label : Core__Option.getOr(ctxHypLabelAndAsrtVarToAsrtHypLabel(label, match$1.symInt), label);
        } else {
          label$1 = label;
        }
        return {
                TAG: "Ok",
                _0: {
                  id: parentNodeId,
                  typ: expr[0],
                  label: label$1,
                  children: children,
                  height: -1
                }
              };
    case "Assertion" :
        var frame = match.frame;
        var args = match.args;
        var this_id = idSeq();
        var this_typ = frame.asrt[0];
        var this_label = frame.label;
        var this_children = new Array(frame.asrt.length - 1 | 0);
        var $$this = {
          id: this_id,
          typ: this_typ,
          label: this_label,
          children: this_children,
          height: -1
        };
        var err = {
          contents: undefined
        };
        frame.asrt.forEach(function (s, i) {
              if (!(i > 0 && Belt_Option.isNone(err.contents))) {
                return ;
              }
              if (s < 0) {
                var symInt = ctxIntToAsrtInt(s);
                this_children[i - 1 | 0] = {
                  TAG: "Symbol",
                  id: idSeq(),
                  symInt: symInt,
                  sym: asrtIntToSym(symInt),
                  color: undefined,
                  isVar: false
                };
                return ;
              }
              var msg = buildSyntaxTreeInner(args[frame.varHyps[s]], ctxIntToAsrtInt, asrtIntToSym, ctxHypLabelAndAsrtVarToAsrtHypLabel, idSeq);
              if (msg.TAG !== "Ok") {
                err.contents = {
                  TAG: "Error",
                  _0: msg._0
                };
                return ;
              }
              this_children[i - 1 | 0] = {
                TAG: "Subtree",
                _0: msg._0
              };
            });
        var err$1 = err.contents;
        if (err$1 !== undefined) {
          return err$1;
        } else {
          return {
                  TAG: "Ok",
                  _0: $$this
                };
        }
    case "AssertionWithErr" :
        return {
                TAG: "Error",
                _0: "Cannot build a syntax tree from a node with an AssertionWithErr proof."
              };
    
  }
}

function buildSyntaxTree(proofNode, ctxIntToAsrtInt, asrtIntToSym, ctxHypLabelAndAsrtVarToAsrtHypLabel) {
  var lastId = {
    contents: -1
  };
  var idSeq = function () {
    lastId.contents = lastId.contents + 1 | 0;
    return lastId.contents;
  };
  return buildSyntaxTreeInner(proofNode, ctxIntToAsrtInt, asrtIntToSym, ctxHypLabelAndAsrtVarToAsrtHypLabel, idSeq);
}

function symEq(a, b) {
  switch (a.TAG) {
    case "Const" :
        switch (b.TAG) {
          case "Const" :
              return a._0 === b._0;
          case "CtxVar" :
          case "AsrtVar" :
              return false;
          
        }
    case "CtxVar" :
        switch (b.TAG) {
          case "CtxVar" :
              return a._0 === b._0;
          case "Const" :
          case "AsrtVar" :
              return false;
          
        }
    case "AsrtVar" :
        switch (b.TAG) {
          case "Const" :
          case "CtxVar" :
              return false;
          case "AsrtVar" :
              return a._0 === b._0;
          
        }
    
  }
}

function arrSymEq(a, b) {
  if (a.length === b.length) {
    return a.every(function (sa, i) {
                return symEq(sa, b[i]);
              });
  } else {
    return false;
  }
}

function symToInt(sym) {
  return sym._0;
}

function hash($$var) {
  return $$var._0;
}

var SymHash = Belt_Id.MakeHashableU({
      hash: hash,
      eq: symEq
    });

function unifSubsMake() {
  return {
          subs: Belt_HashMap.make(16, SymHash),
          newDisj: []
        };
}

function unifSubsGet(unifSubs, sym) {
  return Belt_HashMap.get(unifSubs.subs, sym);
}

function unifSubsSize(unifSubs) {
  return Belt_HashMap.size(unifSubs.subs);
}

function unifSubsReset(unifSubs) {
  Belt_HashMap.clear(unifSubs.subs);
  Expln_utils_common.clearArray(unifSubs.newDisj);
}

function applySubsInPlace(expr, unifSubs) {
  Belt_HashMap.forEach(unifSubs.subs, (function (v, subExpr) {
          var i = 0;
          while(i < expr.length) {
            if (symEq(expr[i], v)) {
              Caml_splice_call.spliceObjApply(expr, "splice", [
                    i,
                    1,
                    subExpr
                  ]);
              i = i + subExpr.length | 0;
            } else {
              i = i + 1 | 0;
            }
          };
        }));
}

function assignSubs(foundSubs, $$var, expr) {
  applySubsInPlace(expr, foundSubs);
  if (expr.some(function (__x) {
          return symEq(__x, $$var);
        })) {
    return false;
  }
  var existingExpr = Belt_HashMap.get(foundSubs.subs, $$var);
  if (existingExpr !== undefined) {
    return arrSymEq(expr, existingExpr);
  } else {
    Belt_HashMap.set(foundSubs.subs, $$var, expr);
    Belt_HashMap.forEach(foundSubs.subs, (function (param, expr) {
            applySubsInPlace(expr, foundSubs);
          }));
    return true;
  }
}

function getAllSymbols(syntaxTreeNode, intToSym) {
  return Expln_utils_common.arrFlatMap(syntaxTreeNode.children, (function (ch) {
                if (ch.TAG === "Subtree") {
                  return getAllSymbols(ch._0, intToSym);
                } else {
                  return [intToSym(ch.symInt)];
                }
              }));
}

function disjForEach(isAsrt, ctxDisj, asrtDisj, consumer) {
  if (isAsrt) {
    return MM_context.disjImmForEach(asrtDisj, consumer);
  } else {
    return MM_context.disjForEach(ctxDisj, consumer);
  }
}

function verifyDisjoints(unifSubs, isAsrt, ctxDisj, asrtDisj, isDisj) {
  var $$continue = {
    contents: true
  };
  disjForEach(isAsrt, ctxDisj, asrtDisj, (function (n, m) {
          if (!$$continue.contents) {
            return ;
          }
          var nSyms = Belt_HashMap.get(unifSubs.subs, isAsrt ? ({
                    TAG: "AsrtVar",
                    _0: n
                  }) : ({
                    TAG: "CtxVar",
                    _0: n
                  }));
          if (nSyms !== undefined) {
            nSyms.forEach(function (nSym) {
                  if (!($$continue.contents && nSym._0 >= 0)) {
                    return ;
                  }
                  var mSyms = Belt_HashMap.get(unifSubs.subs, isAsrt ? ({
                            TAG: "AsrtVar",
                            _0: m
                          }) : ({
                            TAG: "CtxVar",
                            _0: m
                          }));
                  if (mSyms !== undefined) {
                    mSyms.forEach(function (mSym) {
                          if ($$continue.contents && mSym._0 >= 0) {
                            $$continue.contents = !symEq(nSym, mSym);
                            if ($$continue.contents && !isDisj(nSym, mSym)) {
                              unifSubs.newDisj.push([
                                    nSym,
                                    mSym
                                  ]);
                              return ;
                            } else {
                              return ;
                            }
                          }
                          
                        });
                    return ;
                  }
                  
                });
            return ;
          }
          
        }));
  return $$continue.contents;
}

function eqModSubs(subs, a, b) {
  var expr1 = [a];
  applySubsInPlace(expr1, subs);
  var expr2 = [b];
  applySubsInPlace(expr2, subs);
  return arrSymEq(expr1, expr2);
}

function verifyAllDisjoints(unifSubs, ctxDisj, asrtDisj) {
  var isDisj = function (a, b) {
    switch (a.TAG) {
      case "Const" :
          return false;
      case "CtxVar" :
          switch (b.TAG) {
            case "CtxVar" :
                return MM_context.disjContains(ctxDisj, a._0, b._0);
            case "Const" :
            case "AsrtVar" :
                return false;
            
          }
      case "AsrtVar" :
          switch (b.TAG) {
            case "Const" :
            case "CtxVar" :
                return false;
            case "AsrtVar" :
                return MM_context.disjImmContains(asrtDisj, a._0, b._0);
            
          }
      
    }
  };
  if (verifyDisjoints(unifSubs, true, ctxDisj, asrtDisj, isDisj)) {
    return verifyDisjoints(unifSubs, false, ctxDisj, asrtDisj, isDisj);
  } else {
    return false;
  }
}

function unifyPriv(asrtDisj, ctxDisj, a, isMetavarA, intToSymA, b, isMetavarB, intToSymB, foundSubs, $$continue) {
  if (a.typ !== b.typ) {
    $$continue.contents = false;
  } else {
    var match = MM_syntax_tree.isVar(a, isMetavarA);
    if (match !== undefined) {
      var aVar = match[0];
      var match$1 = MM_syntax_tree.isVar(b, isMetavarB);
      if (match$1 !== undefined) {
        var bVar = match$1[0];
        $$continue.contents = eqModSubs(foundSubs, intToSymA(aVar), intToSymB(bVar)) || assignSubs(foundSubs, intToSymA(aVar), [intToSymB(bVar)]);
      } else {
        $$continue.contents = assignSubs(foundSubs, intToSymA(aVar), getAllSymbols(b, intToSymB));
      }
    } else {
      var match$2 = MM_syntax_tree.isVar(b, isMetavarB);
      if (match$2 !== undefined) {
        $$continue.contents = assignSubs(foundSubs, intToSymB(match$2[0]), getAllSymbols(a, intToSymA));
      } else if (a.children.length !== b.children.length) {
        $$continue.contents = false;
      } else {
        var maxI = a.children.length - 1 | 0;
        var i = 0;
        while($$continue.contents && i <= maxI) {
          var aCh = a.children[i];
          if (aCh.TAG === "Subtree") {
            var aCh$1 = aCh._0;
            var bCh = b.children[i];
            if (bCh.TAG === "Subtree") {
              unifyPriv(asrtDisj, ctxDisj, aCh$1, isMetavarA, intToSymA, bCh._0, isMetavarB, intToSymB, foundSubs, $$continue);
            } else {
              $$continue.contents = bCh.isVar && isMetavarB(bCh.sym) && assignSubs(foundSubs, intToSymB(bCh.symInt), getAllSymbols(aCh$1, intToSymA));
            }
          } else {
            var aIsVar = aCh.isVar;
            var aSym = aCh.sym;
            var aInt = aCh.symInt;
            var bCh$1 = b.children[i];
            if (bCh$1.TAG === "Subtree") {
              $$continue.contents = aIsVar && isMetavarA(aSym) && assignSubs(foundSubs, intToSymA(aInt), getAllSymbols(bCh$1._0, intToSymB));
            } else {
              var bInt = bCh$1.symInt;
              $$continue.contents = eqModSubs(foundSubs, intToSymA(aInt), intToSymB(bInt)) || aIsVar && isMetavarA(aSym) && assignSubs(foundSubs, intToSymA(aInt), [intToSymB(bInt)]) || bCh$1.isVar && isMetavarB(bCh$1.sym) && assignSubs(foundSubs, intToSymB(bInt), [intToSymA(aInt)]);
            }
          }
          i = i + 1 | 0;
        };
      }
    }
  }
  $$continue.contents = $$continue.contents && verifyAllDisjoints(foundSubs, ctxDisj, asrtDisj);
}

function intToAsrtSym(i) {
  if (i < 0) {
    return {
            TAG: "Const",
            _0: i
          };
  } else {
    return {
            TAG: "AsrtVar",
            _0: i
          };
  }
}

function intToCtxSym(i) {
  if (i < 0) {
    return {
            TAG: "Const",
            _0: i
          };
  } else {
    return {
            TAG: "CtxVar",
            _0: i
          };
  }
}

function unify(asrtDisj, ctxDisj, asrtExpr, ctxExpr, isMetavar, foundSubs) {
  var $$continue = {
    contents: true
  };
  unifSubsReset(foundSubs);
  unifyPriv(asrtDisj, ctxDisj, asrtExpr, (function (param) {
          return true;
        }), intToAsrtSym, ctxExpr, isMetavar, intToCtxSym, foundSubs, $$continue);
  if ($$continue.contents) {
    return true;
  } else {
    $$continue.contents = true;
    unifSubsReset(foundSubs);
    unifyPriv(asrtDisj, ctxDisj, ctxExpr, isMetavar, intToCtxSym, asrtExpr, (function (param) {
            return true;
          }), intToAsrtSym, foundSubs, $$continue);
    return $$continue.contents;
  }
}

exports.buildSyntaxTree = buildSyntaxTree;
exports.symEq = symEq;
exports.arrSymEq = arrSymEq;
exports.symToInt = symToInt;
exports.unifSubsMake = unifSubsMake;
exports.unifSubsGet = unifSubsGet;
exports.unifSubsSize = unifSubsSize;
exports.unifSubsReset = unifSubsReset;
exports.unify = unify;
/* SymHash Not a pure module */
